import filter from 'lodash.filter';
import config from '../../config';
export default class PreferenceHelper {
    constructor () {
      this.defaultPreferenceId = config.defaultPreferenceId;
    }
    createPreferenceBody (metadata, values, key) {
        let objBody = {};
        switch (metadata) {
          case 'email':
          case 'domain':
            objBody = {
              [key]: {
                [metadata.toUpperCase()]: {
                  ...(values.isBlocked !== undefined) && {'is_blocked': values.isBlocked},
                  'meta_data': metadata,
                  'value': values.value
                }
              }
            };
            break;
          case 'orgDomain':
            objBody = {
              [key]: values.value
            };
            break;
          case 'ipOrDomain':
            objBody = {
              [metadata]: {
                [key]: {
                  value: values.value,
                  ...(values.priority !== undefined) && {'priority': values.priority},
                }
              }
            };
            break;
          case 'discoveryApproverSetting':
            objBody = {
              [key]: {
                'data_subject_project': values.subject,
                'deletion_request': values.deletion,
                'litigation_project': values.litigation
              }
            };
            break;
          case 'listSettings':
            objBody = {
              [key]: {
                ...(key === 'domainBlackListSettings') && {'USE_USER_BLACKLIST': values.enableUserBlackList, 'BLACKLIST_NEEDS_AUTH': values.validateBlackList},
                ...(key === 'domainWhiteListSettings') && {'USE_USER_WHITELIST': values.enableUserWhiteList, 'WHITELIST_NEEDS_AUTH': values.validateWhiteList}
              }
            };
            break;
          case 'businessContinuity':
            objBody = {
              'continuityMode': values.continuityMode
            };
            break;
          case 'availabilityAlert':
            objBody = {
              [metadata]: {
                [key]: values.count
              }
            };
            break;
          case 'subscriber':
            objBody = {
              [key]: values.value
            };
            break;
          case 'footer':
            objBody = {
              'footer': {
                'textFooter': values.text,
                'htmlFooter': values.html
              }
            };
            break;
          case 'mailbox':
            objBody = {
              'mailboxSettings': {
                'ALLOW_USERS_TO_RESET_PASSWORDS_VIA_EMAIL': values.resetPasswords,
                'AUTOMATICALLY_CHANGE_USERS_TO_NOT_ARCHIVED_WHEN_THEY_SEND_OUTGOING_EMAILS': values.changeUsers,
                'AUTOMATICALLY_CREATE_MAILBOXES_WHEN_USERS_SEND_OUTGOING_EMAILS': values.createMailbox,
                'TOKEN_VALIDITY_IN_DAYS': values.oauth
              }
            };
            break;
          case 'virusSetting':
            objBody = {
              [key]: {
                'EMAILS': values.emails,
                'SEND_EMAIL_WARNING_TO_AN_ADMINISTRATOR': values.admin,
                ...(key === 'incomingSettings') && {'SEND_AN_EMAIL_WARNING_TO_THE_RECEIVER': values.senderOrReceiver},
                ...(key === 'outgoingSettings') && {'SEND_AN_EMAIL_WARNING_TO_THE_SENDER': values.senderOrReceiver}
              }
            };
            break;
          case 'spam':
            objBody = {
              'qurantineControl': values.quarantine,
              'spamAlert': values.cron,
              'alertType': {
                'summary': values.alertType
              }
            };
            break;
          case 'timezone':
            objBody = {
              'timezone': values.timezone
            };
            break;
          default:
            objBody = {};
        }
        return objBody;
    }

    checkEmailOrDomain (item, parentKey, key) {
        if (item.data[parentKey]) {
          if (item.data[parentKey].EMAIL) {
            return item.data[parentKey].EMAIL[key];
          } else if (item.data[parentKey].DOMAIN) {
            return item.data[parentKey].DOMAIN[key];
          } else {
            return '';
          }
        } else {
          return '';
        }
    }
    filterPreference (list) {
      return filter(list, (item) => {
        return item.id !== this.defaultPreferenceId;
      });
    }
}